import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { StatusCode } from '../_shared/_enums/Common';
import { FormConfigModel } from '../_shared/_models/Layout/FormConfig';
import { ForgotPasswordQueues } from '../_shared/_models/jobsAndTalents/jobsAndTalentsModels';
import { CommonService } from '@services/app.common.service';

@Component({
    selector: 'app-candidates-forget-password-step1.component',
    templateUrl: './candidatesForgetPasswordStep1.component.html',
    standalone: false
})
export class CandidatesForgetPasswordStep1Component implements OnInit {
  public securityCode = '';
  public systemUserId = '';
  public gSystemUserId = '';
  public StatusCode = StatusCode;
  public candidateid: any;
  public gCandidateid: any;
  public fpSystemUserId: any;
  public fpGuidSystemUserId: any;
  public modalConfig : FormConfigModel;
  public forgotPasswordQueues = {} as ForgotPasswordQueues;

  constructor(
              private route: ActivatedRoute,
              private router: Router,
              public common: CommonService,
              private renderer: Renderer2
              ) {

    this.renderer.removeClass(document.body, 'body-class');
    this.renderer.addClass(document.body, 'body-class-login');

    this.route.queryParams.subscribe((params: Params) => {
      this.candidateid = params['candidateid'];
      this.gCandidateid = params['gCandidateid'];
    });
    this.modalConfig = {
      hideDefaultAction: true,
      hideCard: false
    }
  }

  ngOnInit() {

    this.route.queryParams
      // .filter(params => params.order)
      .subscribe(params => {
        this.systemUserId = params.systemuserid;
        this.gSystemUserId = params.gsystemuserid;
      });

    this.emailSecurityCode();
  }

  emailSecurityCode() {
    this.common.GetData(this.common.ApiUrls.CandidateDetail.EmailSecurityCode + '?userPasswordQueueId=' + this.candidateid + '&candidateGuid=' + this.gCandidateid).then(data => {
      let result = data;
      if (result.status == this.StatusCode.OK) {
        this.forgotPasswordQueues = result.resultData;
        this.forgotPasswordQueues.sYSTEMUSERID = this.forgotPasswordQueues.usersPasswordQueueID;
        this.fpSystemUserId = this.forgotPasswordQueues.usersPasswordQueueID;
        this.forgotPasswordQueues.securitycode = '';
      } else {
        this.common.Notification.error(result.message);
      }
    });
  }

  SubmitSecurityCode() {

    if (this.forgotPasswordQueues.securitycode != this.securityCode) {
      this.forgotPasswordQueues.securitycode = this.securityCode;
    }
    this.common.PostData(this.common.ApiUrls.CandidateDetail.VarifySecurityCode, JSON.stringify(this.forgotPasswordQueues), true).then(data => {
      let result = data;
      if (result.status == this.StatusCode.OK) {
        let url = result.resultData.url;
        this.fpGuidSystemUserId = result.resultData.guid;
        this.common.NavigateToRouteWithQueryString('UpdatePasswordUser', { queryParams: { systemuserid: this.fpSystemUserId, gsystemuserid: this.fpGuidSystemUserId } });
      } else {
        this.common.Notification.error(this.common.GetTranslation('Messages.Error'));
      }
    });
  }
}
